module.exports = __webpack_public_path__ + "static/media/resource-1@3x.fc9339f7.jpg";